<template>
  <div class="title__wrapper">
    <v-container
        style="max-width: 1200px;"
    >
      <span style="color: #FFFFFF; font-weight: bold;">
        診療記録
      </span>
    </v-container>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.title__wrapper {
  height: 45px;
  font-size: 16px;
  background: linear-gradient(
      -130deg, #4ec0d8 0%, #0095d9 55%, #0095d9 100%
  );
}
</style>
